if (!customElements.get('variant-selects')) {
  customElements.define(
    'variant-selects',
    class VariantSelects extends HTMLElement {
      constructor() {
        super();
      }

      get selectedOptionValues() {
        return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
          ({ dataset }) => dataset.optionValueId
        );
      }

      getInputForEventTarget(target) {
        return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
      }

      connectedCallback() {
        this.addEventListener('change', (event) => {
          const target = this.getInputForEventTarget(event.target);
          this.updateSelectedSwatchValue(event);
          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, {
            data: {
              event,
              target,
              selectedOptionValues: this.selectedOptionValues,
            },
          });
        });
      }

      updateSelectedSwatchValue({ target }) {
        const { value, tagName } = target;

        if (tagName === 'SELECT' && target.selectedOptions.length) {
          Array.from(target.options)
            .find((option) => option.getAttribute('selected'))
            .removeAttribute('selected');
          target.selectedOptions[0].setAttribute('selected', 'selected');

          const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
          const selectedDropdownSwatchValue = target
            .closest('.product-form__input')
            .querySelector('[data-selected-value] > .swatch');
          if (!selectedDropdownSwatchValue) return;
          if (swatchValue) {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
            selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
          } else {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
            selectedDropdownSwatchValue.classList.add('swatch--unavailable');
          }

          selectedDropdownSwatchValue.style.setProperty(
            '--swatch-focal-point',
            target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
          );
        } else if (tagName === 'INPUT' && target.type === 'radio') {
          const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
          if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;

                  const skuToShow = value;

                  const radioButtons = document.querySelectorAll('input[type="radio"]');
                
                  radioButtons.forEach(radio => {
                    // Controlla se l'attributo 'sku' è uguale al valore desiderato
                    if (radio.getAttribute('sku') === skuToShow) {
                      // Seleziona il pulsante radio
                      var label = radio.nextElementSibling;
                      var priceElement = label.querySelector('.price');
                      var barcodeElement = label.querySelector('.barcode');
                      var skuElement = label.querySelector('.sku');
                      if (priceElement) {
                          var priceText = priceElement.textContent;
                          var price = parseFloat(priceText.replace('€', '').replace(',', '.'));
                          var installmentPrice = (price / 3).toFixed(2).replace('.', ',');
                          var installmentElement = document.getElementById('installment-amount');
                          if (installmentElement) {
                              installmentElement.textContent = '€' + installmentPrice;
                          }
                      }
                      if(barcodeElement){
                          var barcode = barcodeElement.textContent;
                          var skux = skuElement.textContent;
                          var installmentElement2 = document.getElementById('installment-sku');
                          if (installmentElement2) {
                              installmentElement2.textContent = barcode;
                          }
                      }
                    }
                  });


       
                    
              



                      //COLONNA CODE TO FILTER IMAGE

                      updateGallery(skuToShow);
          
                      
          
                  
                      
          //END COLONNA FILTER IMAGE


          
        }

        // AGGIUNTO DA GIOVANNI COLONNA
   
    

    // Funzione per aggiornare la galleria in base alla variante selezionata
    function updateGallery(skuToShow) {
        const mediaGallery = document.querySelector('.product__media-list'); // Selettore per la galleria principale
        const allMediaItems = mediaGallery.querySelectorAll('.product__media-item'); // Selettore per gli elementi della galleria
        const allMediaThumbs = document.querySelectorAll('.product__thumbs-item'); // Selettore per le miniature
        // Crea array per le immagini visibili
        //const visibleMediaItems = [];
        //const visibleThumbs = [];

        // Nascondi tutte le immagini della galleria e raccogli quelle visibili
        allMediaItems.forEach(item => {
            const imgCheck = item.querySelector('img');
            if (imgCheck && imgCheck.src.includes(skuToShow)) {
                //visibleMediaItems.push(item); // Aggiungi all'array delle immagini visibili
                //item.style.display = 'block';
            } else {
                //item.style.display = 'none'; // Nascondi
            }
        });

        // Nascondi tutte le miniature e raccogli quelle visibili
        var messo = 0;
        allMediaThumbs.forEach(item => {
            const imgCheck2 = item.querySelector('img');
            if (imgCheck2 && imgCheck2.src.includes(skuToShow)) {
                item.style.display = 'block';
                if(messo==0){
                  const largeImageSrc = imgCheck2.src; // Ottieni il src dell'immagine grande
                  const imgCheck3 = allMediaItems[0].querySelector('img');
                  imgCheck3.src = largeImageSrc; // Cambia l'immagine principale
                  imgCheck3.srcset = [];
                  messo = 1;
                }


              
                item.addEventListener('click', function() {
                  console.log("clickkato");
                  const largeImageSrc = imgCheck2.src; // Ottieni il src dell'immagine grande
                  
                  const imgCheck3 = allMediaItems[0].querySelector('img');
                  imgCheck3.src = largeImageSrc; // Cambia l'immagine principale
                  imgCheck3.srcset = [];
                  
                  /*allMediaItems.forEach(item2 => {
                    const imgCheck3 = item2.querySelector('img');
                    console.log("vecchio " + imgCheck3.src);
                    imgCheck3.src = largeImageSrc; // Cambia l'immagine principale
                    imgCheck3.srcset = [];
                    console.log("nuovo " + imgCheck3.src);
                    console.log("fatto" + largeImageSrc);
                  });*/
                
                
                
                });
            } else {
                item.style.display = 'none'; // Nascondi
            }
        });

  
        

      
/*
        // Riordina la galleria
        visibleMediaItems.forEach(item => {
            item.style.display = 'block'; // Mostra le immagini visibili
            mediaGallery.prepend(item); // Aggiungi all'inizio della galleria
        });

        // Riordina le miniature
        const thumbsContainer = document.querySelector('.product__thumbs-list'); // Selettore per il contenitore delle miniature
        visibleThumbs.forEach(item => {
            item.style.display = 'block'; // Mostra le miniature visibili
            thumbsContainer.prepend(item); // Aggiungi all'inizio del contenitore delle miniature
        });
      */
    }
    
        

        // COLONNA FINE

        
        
      }
    }
  );
}


setTimeout(updateGallery2(),3000);


function updateGallery2() {



        const skuToShow = document.querySelectorAll('.sku')[0].innerHTML;
        console.log("okkk " + skuToShow);

  
        const mediaGallery = document.querySelector('.product__media-list'); // Selettore per la galleria principale
        const allMediaItems = mediaGallery.querySelectorAll('.product__media-item'); // Selettore per gli elementi della galleria
        const allMediaThumbs = document.querySelectorAll('.product__thumbs-item'); // Selettore per le miniature
        // Crea array per le immagini visibili
        //const visibleMediaItems = [];
        //const visibleThumbs = [];

        // Nascondi tutte le immagini della galleria e raccogli quelle visibili
        allMediaItems.forEach(item => {
            const imgCheck = item.querySelector('img');
            if (imgCheck && imgCheck.src.includes(skuToShow)) {
                //visibleMediaItems.push(item); // Aggiungi all'array delle immagini visibili
                //item.style.display = 'block';
            } else {
                //item.style.display = 'none'; // Nascondi
            }
        });

        // Nascondi tutte le miniature e raccogli quelle visibili
        var messo = 0;
        allMediaThumbs.forEach(item => {
            const imgCheck2 = item.querySelector('img');
            if (imgCheck2 && imgCheck2.src.includes(skuToShow)) {
                item.style.display = 'block';
                if(messo==0){
                  const largeImageSrc = imgCheck2.src; // Ottieni il src dell'immagine grande
                  const imgCheck3 = allMediaItems[0].querySelector('img');
                  imgCheck3.src = largeImageSrc; // Cambia l'immagine principale
                  imgCheck3.srcset = [];
                  messo = 1;
                }


              
                item.addEventListener('click', function() {
                  console.log("clickkato");
                  const largeImageSrc = imgCheck2.src; // Ottieni il src dell'immagine grande
                  
                  const imgCheck3 = allMediaItems[0].querySelector('img');
                  imgCheck3.src = largeImageSrc; // Cambia l'immagine principale
                  imgCheck3.srcset = [];
                  

                
                
                
                });
            } else {
                item.style.display = 'none'; // Nascondi
            }
        });

  
 
    }